module.exports = {
    handle: (e, data) => {
        if (data.gtmData) {

            const {
                gtmData: {
                    currencyCode,
                    product: {
                        name,
                        id,
                        price,
                        brand,
                        category,
                        variant,
                        quantity
                    }
                }
            } = data;

            dataLayer.push({ ecommerce: null });

            const { customerId, emailAddress } = data.gtmData;

            const productData = {
                'event': 'eec.add',
                'ecommerce': {
                    'currencyCode': currencyCode,
                    'add': {
                        'products': [{
                            'name': name,
                            'id': id,
                            'price': price,
                            'brand': brand,
                            'category': category,
                            'variant': variant,
                            'quantity': quantity
                        }]
                    }
                }
            };

            customerId ? productData.userId = customerId : null;
            emailAddress ? productData.email = emailAddress : null;

            dataLayer.push(productData);
        }
    }
}
